"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _shortid = _interopRequireDefault(require("shortid"));

var _togaDropdown = require("@thinkific/toga-dropdown");

var _togaButton = _interopRequireDefault(require("@thinkific/toga-button"));

var _togaDropdownToggle = _interopRequireDefault(require("@thinkific/toga-dropdown-toggle"));

var _togaTooltip = _interopRequireDefault(require("@thinkific/toga-tooltip"));

var _Select = _interopRequireDefault(require("./Select.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_Select["default"]);
/**
 * React component which allows selection of a single item from a dropdown list
 * Substitute for the native select element.
 */


var Select = /*#__PURE__*/function (_Component) {
  _inherits(Select, _Component);

  var _super = _createSuper(Select);

  function Select(props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleOnSelect", function (option) {
      var onSelect = _this.props.onSelect;

      _this.setState({
        selectLabel: option.selectElement || option.text,
        // We need to call the function with the next content (option.text)
        // otherwise the DOM will have the old value
        overflowActive: _this.isEllipsisVisible(_this.labelSpan, option.text)
      });

      onSelect(option.value);
    });

    _defineProperty(_assertThisInitialized(_this), "renderOptions", function (options) {
      var selectLabel = _this.state.selectLabel;
      var selectedOption = [];
      selectedOption = options.filter(function (option) {
        if (typeof selectLabel === 'string') {
          return option.text === selectLabel;
        }

        return option.text === selectLabel.props.children;
      });
      var currentGroupName;
      return options.map(function (option) {
        var currentGroupNameHeader;

        if (option.group && option.group !== currentGroupName) {
          currentGroupName = option.group;
          currentGroupNameHeader = /*#__PURE__*/_react["default"].createElement(_togaDropdown.ItemHeader, null, option.group);
        }

        return [currentGroupNameHeader, /*#__PURE__*/_react["default"].createElement(_togaDropdown.Item, {
          className: cx('select__item'),
          key: _shortid["default"].generate(),
          title: option.text,
          onClick: function onClick() {
            return _this.handleOnSelect(option);
          }
        }, /*#__PURE__*/_react["default"].createElement(_togaButton["default"], {
          appearance: "knockout",
          className: cx('select__item__button', {
            pressed: selectedOption.includes(option)
          }),
          style: option.style ? option.style : {}
        }, option.selectElement || option.text))];
      });
    });

    _defineProperty(_assertThisInitialized(_this), "isEllipsisVisible", function (e) {
      var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      if (e === undefined) return false;
      if (content !== '') e.innerHTML = content;
      return e.offsetHeight < e.scrollHeight || e.offsetWidth < e.scrollWidth;
    });

    _this.state = {
      overflowActive: false,
      selectLabel: props.selectLabel
    };
    return _this;
  }

  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Check the dimensions of the label since the selectLabel prop can be updated
      this.setState({
        overflowActive: this.isEllipsisVisible(this.labelSpan)
      });
    } // eslint-disable-next-line camelcase

  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState({
        selectLabel: nextProps.selectLabel
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          dimensions = _this$props.dimensions,
          emptyState = _this$props.emptyState,
          filter = _this$props.filter,
          icon = _this$props.icon,
          isDisabled = _this$props.isDisabled,
          isOpen = _this$props.isOpen,
          menuPosition = _this$props.menuPosition,
          width = _this$props.width,
          options = _this$props.options,
          preOptions = _this$props.preOptions,
          wrapperClass = _this$props.wrapperClass;
      var _this$state = this.state,
          overflowActive = _this$state.overflowActive,
          selectLabel = _this$state.selectLabel;
      var toggleClass = cx({
        'select-label': typeof selectLabel === 'string',
        'select-label--flex': _typeof(selectLabel) === 'object'
      });
      var tooltipLabel = overflowActive && typeof selectLabel === 'string' ? selectLabel : '';

      var toggle = /*#__PURE__*/_react["default"].createElement(_togaDropdownToggle["default"], {
        isDisabled: isDisabled
      }, /*#__PURE__*/_react["default"].createElement(_togaTooltip["default"], {
        key: _shortid["default"].generate(),
        title: tooltipLabel
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: cx(toggleClass),
        ref: function ref(_ref) {
          _this2.labelSpan = _ref;
          return _ref;
        }
      }, selectLabel)));

      if (icon) {
        toggle = /*#__PURE__*/_react["default"].createElement(_togaDropdownToggle["default"], {
          icon: icon,
          isDisabled: isDisabled,
          title: selectLabel
        });
      }

      return /*#__PURE__*/_react["default"].createElement(_togaDropdown.Dropdown, {
        className: cx('select__container', wrapperClass),
        dimensions: dimensions,
        filter: filter,
        isOpen: isOpen,
        minWidth: width
      }, toggle, /*#__PURE__*/_react["default"].createElement(_togaDropdown.Menu, {
        className: cx('select__container__menu'),
        emptyState: emptyState,
        position: menuPosition
      }, preOptions && preOptions.length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, this.renderOptions(preOptions), /*#__PURE__*/_react["default"].createElement("hr", {
        className: cx('select__container__pre-options__separator')
      })), this.renderOptions(options)));
    }
  }]);

  return Select;
}(_react.Component);

Select.displayName = 'Select';
Select.propTypes = {
  dimensions: _propTypes["default"].object,
  emptyState: _propTypes["default"].shape({
    description: _propTypes["default"].string,
    icon: _propTypes["default"].string,
    title: _propTypes["default"].string
  }),

  /** Filter options including: isVisible, filterString and placeholder */
  filter: _propTypes["default"].object,

  /** Optional icon */
  icon: _propTypes["default"].string,
  isDisabled: _propTypes["default"].bool,
  isOpen: _propTypes["default"].bool,

  /** Menu position - use right to right-align the menu */
  menuPosition: _propTypes["default"].string,

  /** Array of options (with text, value, group(optional)) */
  options: _propTypes["default"].array.isRequired,

  /** Array of options (with text, value, group(optional)) appearing above
   * options and separated by a horizontal line */
  preOptions: _propTypes["default"].array,

  /** Select label */
  selectLabel: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** Fixed width */
  width: _propTypes["default"].number,

  /** Class attached to the wrapper */
  wrapperClass: _propTypes["default"].string,

  /** Handler called when a selection is made, with the item chosen. */
  onSelect: _propTypes["default"].func.isRequired
};
Select.defaultProps = {
  dimensions: {},
  emptyState: null,
  filter: {
    isVisible: false,
    filterString: '',
    placeholder: null,
    onFilterChange: function onFilterChange() {}
  },
  icon: null,
  isDisabled: false,
  isOpen: false,
  menuPosition: null,
  preOptions: null,
  selectLabel: 'Select',
  width: null,
  wrapperClass: null
};
var _default = Select;
exports["default"] = _default;